import { render, staticRenderFns } from "./Productinformation.vue?vue&type=template&id=7934e777&scoped=true&"
import script from "./Productinformation.vue?vue&type=script&lang=js&"
export * from "./Productinformation.vue?vue&type=script&lang=js&"
import style0 from "./Productinformation.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Productinformation.vue?vue&type=style&index=1&id=7934e777&scoped=true&lang=scss&"
import style2 from "./Productinformation.vue?vue&type=style&index=2&id=7934e777&scoped=true&lang=css&"
import style3 from "./Productinformation.vue?vue&type=style&index=3&id=7934e777&scoped=true&lang=css&"
import style4 from "./Productinformation.vue?vue&type=style&index=4&id=7934e777&scoped=true&lang=css&"
import style5 from "./Productinformation.vue?vue&type=style&index=5&id=7934e777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7934e777",
  null
  
)

export default component.exports